import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './HamburgerMenu.css';

const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button 
        className={`hamburger ${isOpen ? 'open' : ''}`} 
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
      </button>
      
      <div 
        className={`menu-overlay ${isOpen ? 'open' : ''}`}
        onClick={(e) => e.target.className.includes('menu-overlay') && closeMenu()}
      >
        <nav className="menu-links">
          <Link to="/" className="menu-link" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/about" className="menu-link" onClick={closeMenu}>
            About
          </Link>
          <Link to="/services" className="menu-link" onClick={closeMenu}>
            Services
          </Link>
          <Link to="/contact" className="menu-link" onClick={closeMenu}>
            Contact
          </Link>
        </nav>
      </div>
    </>
  );
};

export default HamburgerMenu;